const itemHeight = 72;

document.querySelectorAll(".stat-roller").forEach((roller, index) => {

    const values = roller.dataset.values.split("|");

    const track = document.createElement("div");
    track.className = "stat-roller-track";

    values.forEach(value => {
        const item = document.createElement("div");
        item.className = "stat-roller-item";
        item.textContent = value;
        track.appendChild(item);
    });

    roller.appendChild(track);

    const finalPos = -(values.length - 1) * itemHeight;

    track.style.setProperty("--from", "0px");
    track.style.setProperty("--to", `${finalPos}px`);

});

const observer = new IntersectionObserver((entries) => {

    entries.forEach(entry => {

        if (!entry.isIntersecting) return;

        const track = entry.target.querySelector(".stat-roller-track");

        if (!track.classList.contains("animate")) {
            track.classList.add("animate");
        }

        observer.unobserve(entry.target);

    });

}, {
    threshold: 0.9
});

document.querySelectorAll(".stat-roller").forEach(roller => {
    observer.observe(roller);
});


document.addEventListener("DOMContentLoaded", () => {

    const elements_up = document.querySelectorAll(".fade-up-on-scroll");
    const elements_left = document.querySelectorAll(".fade-left-on-scroll");
    const elements_right = document.querySelectorAll(".fade-right-on-scroll");
    const elements_in = document.querySelectorAll(".fade-in-on-scroll");
    const text_extended = document.querySelectorAll(".extended-text-in");

    const observer = new IntersectionObserver((entries) => {

        entries.forEach(entry => {

            if (!entry.isIntersecting) return;

            const delay = entry.target.dataset.delay || 0;

            setTimeout(() => {
                entry.target.classList.add("is-visible");
            }, delay);

            observer.unobserve(entry.target);

        });

    }, {
        threshold: 0.2,
        rootMargin: "0px 0px -10% 0px"
    });

    elements_up.forEach(el => observer.observe(el));
    elements_left.forEach(el => observer.observe(el));
    elements_right.forEach(el => observer.observe(el));
    elements_in.forEach(el => observer.observe(el));
    text_extended.forEach(el => observer.observe(el));

});

/* Animção Impacto Financeiro */
(function () {
  'use strict';

  var svg = document.getElementById('board-svg');

  if (!svg) return;

  var paths = Array.prototype.filter.call(
    svg.querySelectorAll('path'),
    function (p) { return p.getAttribute('d'); }
  );

  var meta = paths.map(function (p) {
    var len = 0;
    try { len = p.getTotalLength(); } catch (e) {
      var b = p.getBBox();
      len = Math.max(b.width, b.height);
    }
    var m = {
      p: p,
      fill: p.getAttribute('fill') || '#aeb6c2',
      len: isFinite(len) ? len : 0,
      done: false
    };
    p._m = m;
    return m;
  });

  var DUR_MIN = 70;
  var DUR_MAX = 950;
  var SPEED = 0.5;

  function durFor(m) {
    return Math.max(DUR_MIN, Math.min(DUR_MAX, m.len * 0.62)) / SPEED;
  }

  meta.forEach(function (m) {
    var p = m.p;
    p.setAttribute('fill', m.fill);
    p.setAttribute('fill-opacity', 0);
    p.setAttribute('stroke', m.fill);
    p.setAttribute('stroke-opacity', 0.95);
    p.setAttribute('pathLength', 1);
    p.setAttribute('stroke-dasharray', 1);
    p.setAttribute('stroke-dashoffset', 1);
    var b = p.getBBox();
    var size = Math.max(b.width, b.height);
    var sw = Math.max(0.5, size * 0.016);
    p.style.strokeWidth = Math.min(sw, 1).toFixed(2) + 'px';
    p.style.strokeLinecap = 'round';
    p.style.strokeLinejoin = 'round';
    p.style.transition = 'none';
  });

  var reduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var active = [];
  var ticking = false;

  function finish(m) {
    if (m.done) return;
    m.done = true;
    m.p.setAttribute('stroke-dashoffset', 0);
    m.p.style.transition = 'fill-opacity 320ms ease-out';
    m.p.setAttribute('fill-opacity', 0.9);
  }

  function drawPath(m) {
    if (m.done) return;
    active.push({ m: m, t0: performance.now(), dur: durFor(m) });
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(tick);
    }
  }

  function tick(now) {
    var next = [];
    active.forEach(function (d) {
      var k = (now - d.t0) / d.dur;
      if (k >= 1) {
        finish(d.m);
      } else {
        d.m.p.setAttribute('stroke-dashoffset', (1 - k).toFixed(4));
        next.push(d);
      }
    });
    active = next;
    if (active.length) {
      requestAnimationFrame(tick);
    } else {
      ticking = false;
    }
  }

  function drawAll() {
    meta.forEach(finish);
  }

  if (reduced || !('IntersectionObserver' in window)) {
    drawAll();
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && !en.target._m.done) {
          io.unobserve(en.target);
          drawPath(en.target._m);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px' });

    meta.forEach(function (m) { io.observe(m.p); });
  }
})();